
import { useState } from "react";
import { Terminal, History } from "lucide-react";
import { DeviceCommandsSidebar } from "./DeviceCommandsSidebar";
import { DeviceCommandsContent } from "./DeviceCommandsContent";

interface Device {
  id: string;
  name: string;
  user: string;
  os: string;
  version: string;
  status: "active" | "prepared" | "inactive" | "registered" | "in_process";
  lastSync: string;
  group: string;
}

interface DeviceCommandsTabProps {
  device: Device;
}

const commandsSidebarItems = [
  { id: "commands", label: "Commands", icon: Terminal },
  { id: "history", label: "History", icon: History },
];

export const DeviceCommandsTab = ({ device }: DeviceCommandsTabProps) => {
  const [activeCommandsSection, setActiveCommandsSection] = useState("commands");

  // Show "not available" for registered or prepared devices
  if (device.status === "registered" || device.status === "prepared") {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-muted-foreground text-lg">Not available</p>
          <p className="text-sm text-muted-foreground mt-2">
            Commands are only available when the device is active
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 h-full">
      <DeviceCommandsSidebar
        items={commandsSidebarItems}
        activeSection={activeCommandsSection}
        onSectionChange={setActiveCommandsSection}
      />
      <div className="flex-1 h-full overflow-auto">
        <DeviceCommandsContent device={device as any} activeSection={activeCommandsSection} />
      </div>
    </div>
  );
};
